module.exports = __webpack_public_path__ + "static/scale-model-of-ghost-town-museum-in-colorado-springs-colorado-fe81f534a93927e68236c03ebb7fe8ec.png";